<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <button class="btn btn-sm btn-primary" @click="loadTables">Carica tabelle dal DB</button>
            <button class="btn btn-sm btn-success ms-2" @click="saveAndApply">Salva e applica indici</button>
            <input type="text" class="form-control form-control-sm ms-3 w-auto" v-model="filter" placeholder="Filtra tabelle" />
            <label class="ms-3 mb-0">
                <input type="checkbox" v-model="onlyIndexed" /> Solo tabelle con indici
            </label>
        </div>

        <div class="text-danger mb-3" v-for="(item, i) in missingItems" :key="'m' + i">
            <button class="btn btn-danger btn-sm" @click="removeMissing(item.table, item.column)">-</button>
            <template v-if="item.column">
                Colonna <b>{{item.column}}</b> non presente nella tabella <b>{{item.table}}</b>
            </template>
            <template v-else>
                Tabella <b>{{item.table}}</b> non presente nel DB
            </template>
        </div>

        <div class="mb-3 pre" v-if="applyResult">
            <b>Esito applicazione indici:</b>
            <div v-if="applyResult.length == 0">Nessun errore</div>
            <div v-for="(line, i) in applyResult" :key="i">{{line}}</div>
        </div>

        <accordion v-for="table in filteredTables" :key="table.name" class="mb-2">
            <template #title>
                <div>
                    <span><b>{{table.name}}</b>
                        <template v-if="getFlagged(table.name).length > 0">
                            ({{getFlagged(table.name).length}} indici)
                        </template>
                    </span>
                </div>
            </template>
            <div class="p-2 bg-white">
                <table class="table table-striped">
                    <thead>
                        <th>Indicizza</th>
                        <th>Colonna</th>
                        <th>Tipo</th>
                        <th>Descrizione</th>
                        <th>Indici presenti</th>
                        <th>Stato</th>
                    </thead>
                    <tbody>
                        <tr v-for="column in table.columns" :key="column.name">
                            <td>
                                <toggler :modelValue="isFlagged(table.name, column.name)" @update:modelValue="setFlag(table.name, column.name, $event)"></toggler>
                            </td>
                            <td>{{column.name}}</td>
                            <td>{{column.dataType}}</td>
                            <td>{{column.comment}}</td>
                            <td>{{column.indexes.join(", ")}}</td>
                            <td>
                                <span v-if="isFlagged(table.name, column.name) && isApplied(column)" class="text-success">attivo</span>
                                <span v-else-if="isFlagged(table.name, column.name)" class="text-warning">da applicare</span>
                                <span v-else-if="isApplied(column)" class="text-danger">da rimuovere</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </accordion>
    </div>
</template>

<script lang="ts">
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';
import WithModel from '@/mixins/withModel';
import { AppConfigClient } from '@/services/Services';

const indexPrefix = "dw_idx_";

@Options({})
export default class tableIndexes extends mixins(WithModel) {

    declare localValue: { [key: string]: string[]; };

    @Prop() save: () => Promise<any>;

    tables: OM.DbTableInfo[] = null;
    filter: string = "";
    onlyIndexed: boolean = false;
    applyResult: string[] = null;

    loadTables(){
        return AppConfigClient.getDbTables()
        .then(x => {
            this.tables = x;
        })
    }

    saveAndApply(){
        this.save()
        .then(() => AppConfigClient.applyIndexes())
        .then(x => {
            this.applyResult = x;
            return this.loadTables();
        })
    }

    get filteredTables(){
        if(!this.tables)
            return [];
        let filter = this.filter.toLowerCase();
        return this.tables.filter(x => x.name.toLowerCase().indexOf(filter) > -1
            && (!this.onlyIndexed || this.getFlagged(x.name).length > 0 || x.columns.some(c => this.isApplied(c))));
    }

    get missingItems(){
        if(!this.tables)
            return [];
        let ris: { table: string, column: string }[] = [];
        for(let tableName in this.localValue){
            let table = this.tables.find(x => x.name == tableName);
            if(!table){
                ris.push({ table: tableName, column: null });
                continue;
            }
            this.localValue[tableName]
                .filter(x => !table.columns.some(c => c.name == x))
                .forEach(x => ris.push({ table: tableName, column: x }));
        }
        return ris;
    }

    getFlagged(tableName: string){
        return this.localValue[tableName] || [];
    }

    isFlagged(tableName: string, columnName: string){
        return this.getFlagged(tableName).indexOf(columnName) > -1;
    }

    isApplied(column: OM.DbColumnInfo){
        return column.indexes.some(x => x.startsWith(indexPrefix));
    }

    setFlag(tableName: string, columnName: string, value: boolean){
        let columns = this.getFlagged(tableName).filter(x => x != columnName);
        if(value)
            columns.push(columnName);

        if(columns.length > 0)
            this.localValue[tableName] = columns;
        else
            delete this.localValue[tableName];
    }

    removeMissing(tableName: string, columnName: string){
        if(columnName)
            this.setFlag(tableName, columnName, false);
        else
            delete this.localValue[tableName];
    }

}
</script>
